import { Routes, Route } from "react-router-dom";
import Pages from "./pages";
import { ENUM_ROUTES } from "./RoutesEnum";

const Routing = () => {
  return (
    <Routes>
      <Route path="/" element={<Pages.Login />} />
      <Route path="/forgot-password" element={<Pages.ForgotPassword />} />
      <Route path="/otp" element={<Pages.OtpVerification />} />
      <Route path="/reset-password" element={<Pages.ResetPassword />} />
      <Route path="/dashboard" element={<Pages.Dashboard />} />
      <Route path="/manage-categories" element={<Pages.ManageCategories />} />
      <Route
        path="/manage-categories/subcategory/:id"
        element={<Pages.SubcategoryPage />}
      />
      <Route path="/manage-customers" element={<Pages.ManageUsers />} />
      <Route
        path="/manage-user/detail/:id"
        element={<Pages.ManageUserDetail />}
      />
      <Route
        path="/manage-owner/detail/:id"
        element={<Pages.ManageOwnerDetail />}
      />
      <Route path="/manage-customers/add" element={<Pages.AddUser />} />
      <Route path="/manage-customers/edit/:id" element={<Pages.AddUser />} />
      <Route
        path="/manage-maintenance-team"
        element={<Pages.ManageMaintenanceTeam />}
      />
      <Route
        path="/manage-booking/detail/:id"
        element={<Pages.BookingDetails />}
      />
      <Route path="/manage-maintenance-team/add" element={<Pages.AddTeam />} />
      <Route
        path="/manage-venue-owners"
        element={<Pages.ManageVenueOwners />}
      />
      <Route
        path="/manage-venue-owners/add"
        element={<Pages.AddVenueOwner />}
      />
      <Route
        path="/manage-venue-owners/edit/:id"
        element={<Pages.AddVenueOwner />}
      />
      <Route
        path="/manage-venue-owners/details/:id"
        element={<Pages.VenueOwnerDetails />}
      />
      <Route
        path="/manage-storage-owners"
        element={<Pages.ManageStorageOwners />}
      />
      <Route
        path="/manage-storage-owners/add"
        element={<Pages.AddStorageOwner />}
      />
      <Route
        path="/manage-storage-owners/edit"
        element={<Pages.EditStorageOwner />}
      />
      <Route path="/manage-payments" element={<Pages.ManagePayments />} />
      <Route path="/manage-host-payout" element={<Pages.ManageHostPayout />} />
      <Route path={ENUM_ROUTES.MANAGE_REFUNDS} element={<Pages.ManageRefunds />} />
      {/* <Route path={`${ENUM_ROUTES.REFUND_DETAILS}/:id`} element={<Pages.RefundDetails />} /> */}
      <Route path="/manage-subadmin" element={<Pages.ManageSubadmin />} />
      <Route path="/manage-subadmin/add" element={<Pages.AddSubadmin />} />
      <Route path="/manage-subadmin/edit/:id" element={<Pages.AddSubadmin />} />
      <Route
        path="/manage-subadmin/detail/:id"
        element={<Pages.SubadminDetail />}
      />
      <Route
        path="/manage-subadmin/roles"
        element={<Pages.ManageSubadminRoles />}
      />
      <Route path="/manage-subadmin/roles/add" element={<Pages.AddRole />} />
      <Route path="/manage-subadmin/roles/edit/:id" element={<Pages.AddRole />} />
      <Route
        path="/manage-subadmin/roles/detail/:id"
        element={<Pages.RoleDetail />}
      />
      <Route path="/revenue-analytics" element={<Pages.ManageAnalytics />} />
      <Route
        path="/manage-customer-support"
        element={<Pages.ManageCustomerSupport />}
      />
      <Route
        path="/manage-notifications"
        element={<Pages.ManageNotifications />}
      />
      <Route
        path="/recieved-notifications"
        element={<Pages.RecievedNotifications />}
      />
      <Route path="/manage-reviews" element={<Pages.ManageReviews />} />
      <Route path="/manage-cms" element={<Pages.ManageCms />} />
      <Route path="/manage-profile" element={<Pages.ManageProfile />} />
      <Route path="/manage-profile/edit" element={<Pages.EditProfile />} />
      <Route
        path="/manage-profile/change-password"
        element={<Pages.ChangePassword />}
      />
      <Route
        path="/manage-booking-requests"
        element={<Pages.ManageBooking />}
      />
      <Route
        path="/manage-booking-requests/add"
        element={<Pages.AddBooking />}
      />{" "}
      <Route
        path="/manage-booking-requests/details"
        element={<Pages.ViewBookingDetails />}
      />
      <Route
        path={ENUM_ROUTES.MANAGE_LOYALTY_POINTS}
        element={<Pages.ManageLoyaltyPoints />}
      />
      <Route
        path={ENUM_ROUTES.LOYALTY_POINTS_DETAILS}
        element={<Pages.LoyaltyPointsDetails />}
      />
      <Route
        path={"/manage-loyalty-points/edit/:id"}
        element={<Pages.EditLoyaltyPoints />}
      />
      <Route
        path={"/manage-categories/details/:id"}
        element={<Pages.CategoryDetails />}
      />
      <Route
        path={ENUM_ROUTES.MANAGE_FACILITIES}
        element={<Pages.ManageFacilities />}
      />
      <Route
        path={ENUM_ROUTES.MANAGE_BANNERS}
        element={<Pages.ManageBanner />}
      />
      <Route
        path={`${ENUM_ROUTES.BANNERS_DETAILS}/:id`}
        element={<Pages.ManageBannerDetails />}
      />
      <Route
        path={`${ENUM_ROUTES.EDIT_BANNERS}/:id`}
        element={<Pages.AddBanner />}
      />
      <Route path={ENUM_ROUTES.ADD_BANNERS} element={<Pages.AddBanner />} />
      <Route
        path={ENUM_ROUTES.DISCOUNT_COUPON_MANAGEMENT}
        element={<Pages.ManageDiscount />}
      />
      <Route path={ENUM_ROUTES.ADD_DISCOUNT} element={<Pages.AdDiscount />} />
      <Route
        path={`${ENUM_ROUTES.EDIT_DISCOUNT}/:id`}
        element={<Pages.AdDiscount />}
      />
      <Route
        path={`${ENUM_ROUTES.DISCOUNT_DETAILS}/:id`}
        element={<Pages.DiscountDetails />}
      />
      <Route
        path={ENUM_ROUTES.ADD_RECOMMENDED_VENUE}
        element={<Pages.EditRecommendedVenue />}
      />
      <Route
        path={ENUM_ROUTES.RECOMMENDED_VENUE_DETAILS}
        element={<Pages.RecommendedVenueDetails />}
      />
      <Route
        path={ENUM_ROUTES.RECOMMENDED_VENUE}
        element={<Pages.ManageRecommendedVenue />}
      />
      <Route path={ENUM_ROUTES.ADD_NEWS} element={<Pages.AddNews />} />
      <Route
        path={`${ENUM_ROUTES.EDIT_NEWS}/:id`}
        element={<Pages.AddNews />}
      />
      <Route
        path={`${ENUM_ROUTES.NEWS_DETAILS}/:id`}
        element={<Pages.NewsDetails />}
      />
      <Route path={ENUM_ROUTES.MANAGE_NEWS} element={<Pages.ManageNews />} />
      <Route
        path={ENUM_ROUTES.ADD_AMENITIES}
        element={<Pages.AddAmenities />}
      />
      <Route
        path={ENUM_ROUTES.AMENITIES_DETAILS}
        element={<Pages.AmenitiesDetails />}
      />
      <Route
        path={ENUM_ROUTES.MANAGE_AMENITIES}
        element={<Pages.ManageAmenities />}
      />
      <Route path={ENUM_ROUTES.MANAGE_FAQ} element={<Pages.ManageFaq />} />
      // Blog Management
      <Route path={ENUM_ROUTES.MANAGE_BLOGS} element={<Pages.ManageBlogs />} />
      <Route path={ENUM_ROUTES.ADD_BLOG} element={<Pages.AddBlog />} />
      <Route
        path={`${ENUM_ROUTES.EDIT_BLOG}/:id`}
        element={<Pages.AddBlog />}
      />
      <Route
        path={`${ENUM_ROUTES.BLog_DETAILS}/:id`}
        element={<Pages.BlogDetails />}
      />
    </Routes>
  );
};

export default Routing;
